import { render, staticRenderFns } from "./PopulationInformation.vue?vue&type=template&id=75c576a0&scoped=true"
import script from "./PopulationInformation.vue?vue&type=script&lang=js"
export * from "./PopulationInformation.vue?vue&type=script&lang=js"
import style0 from "./PopulationInformation.vue?vue&type=style&index=0&id=75c576a0&prod&scoped=true&lang=css"
import style1 from "./PopulationInformation.vue?vue&type=style&index=1&id=75c576a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c576a0",
  null
  
)

export default component.exports